import { createContext, useContext } from 'react';

export interface AuthContextValue {
  isAuthLoaded: boolean;
}

export const AuthContext = createContext({} as AuthContextValue);
AuthContext.displayName = 'AuthContext';

export function useAppContext() {
  return useContext(AuthContext);
}
